export const profane = new Set([
  'bitch',
  'bitches',
  'bitching',
  'boffing',
  'bollock',
  'bollocks',
  'bugger',
  'cawks',
  'chink',
  'chinkie',
  'chinkies',
  'cocks',
  'cummer',
  'cunts',
  'dickhead',
  'dinks',
  'dogging',
  'dykes',
  'dykey',
  'dykier',
  'dykiest',
  'dyking',
  'fagged',
  'faggery',
  'faggier',
  'faggiest',
  'fagging',
  'fagging',
  'faggings',
  'faggot',
  'faggoted',
  'faggotry',
  'faggots',
  'faggoty',
  'faggy',
  'fagot',
  'fagots',
  'fanny',
  'flange',
  'fucked',
  'fucker',
  'fuckers',
  'fucking',
  'fuckings',
  'fuckoff',
  'fuckoffs',
  'fucks',
  'fuckups',
  'fuckwit',
  'fuckwits',
  'gangbang',
  'goddamn',
  'honkey',
  'knobhead',
  'kraut',
  'lesbo',
  'mutha',
  'nazis',
  'nigger',
  'niggers',
  'pecker',
  'penis',
  'perse',
  'pissed',
  'pisser',
  'pissers',
  'pisses',
  'pissing',
  'prick',
  'pricks',
  'rimming',
  'schlong',
  'schmuck',
  'scrote',
  'semen',
  'sluts',
  'slutty',
  'smegma',
  'testicle',
  'titties',
  'tosser',
  'wanker',
  'wanky',
  'whore',
  'willies',
  'willy',
])

export const sensitive = new Set([
  'abort',
  'aborted',
  'abortee',
  'abortees',
  'aborter',
  'aborters',
  'aborting',
  'abortion',
  'aborts',
  'abortus',
  'anal',
  'anally',
  'arse',
  'ass',
  'asshole',
  'assholes',
  'balls',
  'ballsy',
  'bastard',
  'bastards',
  'bastardy',
  'bisexual',
  'bitch',
  'bitched',
  'bitcher',
  'bitchers',
  'bitches',
  'bitchier',
  'bitchily',
  'bitchin',
  'bitching',
  'bitchy',
  'bloody',
  'blowjob',
  'blowjobs',
  'bollock',
  'bollok',
  'boner',
  'boners',
  'boobie',
  'boobies',
  'boobs',
  'booby',
  'boobyish',
  'boobyism',
  'breast',
  'breasted',
  'breasts',
  'bullshit',
  'butthole',
  'buttock',
  'buttocks',
  'buttplug',
  'butts',
  'cannabis',
  'clit',
  'clitoral',
  'clitoric',
  'clitoris',
  'clits',
  'cockade',
  'cockaded',
  'cockades',
  'cocked',
  'cocker',
  'cockers',
  'coons',
  'coonskin',
  'crapped',
  'crapper',
  'crappers',
  'crappie',
  'crappier',
  'crappies',
  'crapping',
  'crappy',
  'crapy',
  'damnable',
  'damnably',
  'damndest',
  'damned',
  'damning',
  'damns',
  'dicked',
  'dickens',
  'dicker',
  'dickered',
  'dickers',
  'dickhead',
  'dickie',
  'dickier',
  'dickies',
  'dickiest',
  'dicking',
  'dicks',
  'dicky',
  'dildo',
  'dildos',
  'dinked',
  'dipshit',
  'dogging',
  'doggings',
  'doggish',
  'dumbshit',
  'fecked',
  'feckin',
  'fecking',
  'fellate',
  'fellated',
  'fellates',
  'fellatio',
  'fellator',
  'fisted',
  'gangbang',
  'gayer',
  'gayest',
  'gayety',
  'gayness',
  'goddam',
  'goddamn',
  'goddamns',
  'hardcore',
  'hell',
  'hellhole',
  'hells',
  'homosex',
  'horniest',
  'hornily',
  'horning',
  'hornist',
  'horny',
  'idiot',
  'idiotcy',
  'idiotic',
  'idiots',
  'jizzes',
  'kegged',
  'kegger',
  'keggers',
  'kegging',
  'kegler',
  'knobbed',
  'knobed',
  'knobend',
  'knobhead',
  'labia',
  'labial',
  'labially',
  'labials',
  'lusted',
  'luster',
  'lustful',
  'lustier',
  'lustiest',
  'lustily',
  'lusting',
  'lustless',
  'lusts',
  'mofos',
  'mornic',
  'moron',
  'morons',
  'muffed',
  'mutha',
  'muthas',
  'nazified',
  'nazifies',
  'nazify',
  'nazis',
  'nutting',
  'orgasm',
  'orgasmed',
  'orgasmic',
  'orgasms',
  'orgastic',
  'pecker',
  'peckers',
  'penis',
  'penises',
  'pigface',
  'pimped',
  'pimping',
  'pimple',
  'pimpled',
  'pimples',
  'pimplier',
  'pimply',
  'pissed',
  'pisser',
  'pissers',
  'pisses',
  'pisshead',
  'pissing',
  'pooped',
  'pooper',
  'poopers',
  'poopiest',
  'pooping',
  'poops',
  'porno',
  'pornos',
  'porns',
  'porny',
  'prick',
  'pricked',
  'pricks',
  'pubes',
  'pubis',
  'pusses',
  'pussier',
  'pussies',
  'pussiest',
  'pussy',
  'rectum',
  'rectums',
  'rectus',
  'retard',
  'retarded',
  'retarder',
  'retards',
  'rimming',
  'rimmings',
  'sadist',
  'sadistic',
  'schlong',
  'schlongs',
  'screwing',
  'screws',
  'scrotal',
  'scrote',
  'scrotum',
  'scrotums',
  'semen',
  'semens',
  'shagged',
  'shaggier',
  'shaggily',
  'shagging',
  'shite',
  'shitead',
  'shited',
  'shites',
  'shithole',
  'shiting',
  'shitless',
  'shitlist',
  'shitload',
  'shits',
  'shitted',
  'shitters',
  'shittier',
  'shittily',
  'shitty',
  'skank',
  'skanked',
  'skanker',
  'skankers',
  'skankier',
  'skanking',
  'skanks',
  'skanky',
  'sluts',
  'sluttery',
  'sluttier',
  'sluttish',
  'slutty',
  'unsexy',
  'smegma',
  'smegmas',
  'smuts',
  'smutted',
  'smuttier',
  'smuttily',
  'smutting',
  'smutty',
  'snatch',
  'snatched',
  'snatcher',
  'snatches',
  'spunk',
  'spunked',
  'spunkier',
  'spunkily',
  'spunking',
  'testicle',
  'tittie',
  'titties',
  'titting',
  'tittling',
  'titty',
  'titular',
  'tosser',
  'tossers',
  'turds',
  'twats',
  'twinks',
  'wangs',
  'wanker',
  'wankers',
  'waknier',
  'wankiest',
  'wanking',
  'wanks',
  'whore',
  'whored',
  'whoredom',
  'whores',
  'whoreson',
  'whoring',
  'whorish',
  'willie',
  'willies',
])
